__turbopack_context__.v({
  "actions": "Login-module__Gqe8HW__actions",
  "form": "Login-module__Gqe8HW__form",
  "root": "Login-module__Gqe8HW__root",
});
